import * as fromInstagram from './instagram.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'instagram';

export interface InstagramModuleState {
  instaPosts: fromInstagram.InstagramState;
}

export const reducers: ActionReducerMap<InstagramModuleState> = {
  instaPosts: fromInstagram.InstaPostReducer,
};

export const getInstagramModuleState = createFeatureSelector<InstagramModuleState>(featureKey);

export const metaReducers: MetaReducer<InstagramModuleState>[] = !environment.production ? [] : [];
